import { Facebook, ExternalLink } from "lucide-react";

/**
 * A branded fallback when a Facebook post/reel can't be embedded
 * (private, unlisted, or "share only via link" reels can't be embedded).
 * Always renders — no runtime detection needed.
 */
export function FacebookCard({ url, label = "Watch on Facebook", cover }) {
  return (
    <div className="relative overflow-hidden border" style={{ borderColor: "hsl(var(--border-hsl))" }} data-testid="fb-fallback">
      {cover && (
        <div className="absolute inset-0 opacity-40">
          <img src={cover} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="relative bg-gradient-to-br from-[#1877F2]/95 to-[#0a4aa0]/95 text-white p-10 flex flex-col items-center justify-center min-h-[420px]">
        <Facebook size={48} className="mb-4 opacity-90" />
        <div className="kicker opacity-80 mb-2">Julia on Facebook</div>
        <div className="font-serif text-3xl md:text-4xl font-bold mb-6 text-center max-w-md leading-tight">
          {label}
        </div>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 bg-white text-[#1877F2] font-bold uppercase text-xs tracking-widest px-6 py-3 hover:bg-white/90 transition-colors"
          data-testid="fb-fallback-cta"
        >
          Open on Facebook <ExternalLink size={14} />
        </a>
        <p className="mt-6 text-xs opacity-70 max-w-md text-center">
          Facebook Reels can&apos;t always be embedded due to their privacy settings.
          Click above to watch the original on facebook.com.
        </p>
      </div>
    </div>
  );
}
